"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var Mode = {
  CONTAIN: {
    name: 'contain',
    icon: 'el-icon-full-screen'
  },
  ORIGINAL: {
    name: 'original',
    icon: 'el-icon-c-scale-to-original'
  }
};
var _default = exports.default = {
  name: 'Pdf',
  props: {
    pdfUrl: {
      type: String,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '未命名.pdf'
    },
    staticFile: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      mode: Mode.ORIGINAL,
      loading: false
    };
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  },
  methods: {
    /* 隐藏 */hide: function hide() {
      this.$emit('update:visible', false);
    }
  }
};